import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { giftCategories } from '../mockData';
import Logo from '../components/Logo';
import GiftCheckout from '../components/GiftCheckout';

const API_ENDPOINTS = {
    giftGetPublicList: 'https://gift-getpubliclist-336444799661.us-central1.run.app/giftGetPublicList',
    giftGetCoupleGifts: 'https://gift-getcouplesgift-336444799661.us-central1.run.app/giftGetCoupleGifts',
    contactSendEmail: 'https://gift-contactsendemail-336444799661.us-central1.run.app'
};

const PublicGiftList = () => {
    const { coupleId } = useParams();
    const [couple, setCouple] = useState(null);
    const [gifts, setGifts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [selectedGift, setSelectedGift] = useState(null);
    const [checkoutGift, setCheckoutGift] = useState(null);
    const [showEventDetails, setShowEventDetails] = useState(false);
    const [eventOpen, setEventOpen] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
    const [contactFormData, setContactFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [contactSubmitted, setContactSubmitted] = useState(false);
    const [contactLoading, setContactLoading] = useState(false);
const [sortMode, setSortMode] = useState("relevancia");
const [showBackToTop, setShowBackToTop] = useState(false);

useEffect(() => {
  const onScroll = () => {
    setShowBackToTop(window.scrollY > 600); // ajustá el umbral si querés
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
  return () => window.removeEventListener("scroll", onScroll);
}, []);

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
    useEffect(() => {
        const handleOpenCheckout = (e) => {
            const giftData = e.detail;
            setCheckoutGift(giftData);
        };

        window.addEventListener('openGiftCheckout', handleOpenCheckout);
        return () => window.removeEventListener('openGiftCheckout', handleOpenCheckout);
    }, []);

    useEffect(() => {
        if (showEventDetails) {
            setEventOpen(true);
        } else {
            setEventOpen(false);
        }
    }, [showEventDetails]);

    useEffect(() => {
        const handleCloseDetail = () => {
            setSelectedGift(null);
        };

        window.addEventListener('closeGiftDetail', handleCloseDetail);
        return () => window.removeEventListener('closeGiftDetail', handleCloseDetail);
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${API_ENDPOINTS.giftGetPublicList}?coupleId=${coupleId}`);
                const data = await response.json();

                if (data.success) {
                    setCouple(data.couple);
                    setGifts(data.gifts);
                } else {
                    console.error('Error:', data.error);
                }
            } catch (error) {
                console.error('Error fetching public list:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [coupleId]);

    const refreshGifts = async () => {
        if (!coupleId) return;

        try {
            const response = await fetch(`${API_ENDPOINTS.giftGetCoupleGifts}?coupleId=${coupleId}`);
            const data = await response.json();

            if (data.success) {
                setGifts(data.data);
            }
        } catch (error) {
            console.error('Error refreshing gifts:', error);
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent-500"></div>
            </div>
        );
    }

    if (!couple) {
        return (
            <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="text-6xl mb-4">😕</div>
                    <h1 className="text-2xl font-display font-bold text-neutral-900 mb-2">
                        Lista no encontrada
                    </h1>
                    <p className="text-neutral-600">
                        No pudimos encontrar esta lista de regalos
                    </p>
                </div>
            </div>
        );
    }

    const handleContactChange = (e) => {
        setContactFormData({
            ...contactFormData,
            [e.target.name]: e.target.value
        });
    };

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        setContactLoading(true);

        try {
            const response = await fetch(API_ENDPOINTS.contactSendEmail, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(contactFormData)
            });

            const data = await response.json();

            if (data.success) {
                setContactSubmitted(true);
            } else {
                alert('❌ Error al enviar el mensaje. Por favor intentá de nuevo.');
            }
        } catch (error) {
            console.error('Error sending contact email:', error);
            alert('❌ Error al enviar el mensaje. Por favor intentá de nuevo.');
        } finally {
            setContactLoading(false);
        }
    };

    // const filteredGifts = selectedCategory === 'all'
    //     ? gifts
    //     : gifts.filter(g => g.category === selectedCategory);

    // // ✅ CAMBIO: Mostrar todos los regalos (no filtrar por reserved)
    // const availableGifts = filteredGifts;

    const filteredGifts =
  selectedCategory === "all"
    ? gifts
    : gifts.filter((g) => g.category === selectedCategory);

const getProgress = (g) => {
  const price = g.price || 0;
  if (!price) return 0; // por si algún item raro viene sin price
  return (g.amountReceived || 0) / price;
};

const sortedGifts = [...filteredGifts].sort((a, b) => {
  const pA = getProgress(a);
  const pB = getProgress(b);

  const isCompletedA = pA >= 1;
  const isCompletedB = pB >= 1;

  switch (sortMode) {
    case "libres":
      if (isCompletedA !== isCompletedB) return isCompletedA ? 1 : -1;
      return pA - pB; // dentro de libres, menos avanzado primero

    case "completados":
      if (isCompletedA !== isCompletedB) return isCompletedA ? -1 : 1;
      return pB - pA; // dentro de completados, más avanzado primero

    case "precioAsc":
      return (a.price || 0) - (b.price || 0);

    case "precioDesc":
      return (b.price || 0) - (a.price || 0);

    case "relevancia":
    default:
      // Relevancia: libres primero, luego los más cerca de completarse (más “social proof”)
      if (isCompletedA !== isCompletedB) return isCompletedA ? 1 : -1;
      return pB - pA; // más avanzado primero (pero <100%)
  }
});

const availableGifts = sortedGifts;

    const formatPrice = (price) => {
        const currency = couple.preferences?.currency || 'ARS';

        return new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 0
        }).format(price);
    };

    const formatDate = (value) => {
        if (!value) return "";

        const d = typeof value?.toDate === "function" ? value.toDate() : new Date(value);

        return new Intl.DateTimeFormat("es-AR", {
            timeZone: "UTC",
            year: "numeric",
            month: "long",
            day: "numeric",
        }).format(d);
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-accent-50 via-white to-primary-50">
            {/* Header */}
            <header className="bg-white/80 backdrop-blur-sm border-b border-neutral-200 sticky top-0 z-40">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
                    {/* MOBILE */}
                    <div className="sm:hidden flex items-start justify-between gap-3">
                        <div className="min-w-0">
                            <Logo className="h-11 w-auto" />
                        </div>

                        <button
                            onClick={() => setShowEventDetails(true)}
                            className="shrink-0 inline-flex items-center gap-2 px-3 py-2
                   rounded-lg bg-white border border-neutral-200
                   text-neutral-700 hover:bg-neutral-50
                   transition-colors font-medium shadow-sm"
                            aria-label="Detalles del evento"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            <span>Evento</span>
                        </button>
                    </div>

                    {/* DESKTOP */}
                    <div className="hidden sm:block">
                        <div className="grid grid-cols-3 items-center">
                            <div className="justify-self-start">
                                <Logo className="h-10 sm:h-12" />
                            </div>

                            <div />

                            <div className="justify-self-end">
                                <button
                                    onClick={() => setShowEventDetails(true)}
                                    className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 rounded-full
          bg-white/70 backdrop-blur border border-neutral-200/70
          text-neutral-700 hover:bg-white transition-colors
          font-medium shadow-sm"
                                >
                                    <span className="hidden sm:inline">Detalles</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Hero Section */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="relative overflow-hidden rounded-3xl border border-neutral-200 bg-white/80 backdrop-blur shadow-sm">
                    <div className="relative h-28 overflow-hidden rounded-t-3xl">
                        {/* {couple.profileImage && (
                            <img
                                src={couple.profileImage}
                                alt=""
                                className="w-full h-full object-cover opacity-30"
                            />
                        )} */}
                        <div className="absolute inset-0 bg-gradient-to-r from-accent-500/25 via-white/40 to-primary-500/25" />
                    </div>

                    <div className="relative px-6 sm:px-10 pb-8 sm:pb-10 pt-10 sm:pt-12 text-center">
                        <div className="absolute left-1/2 -translate-x-1/2 -top-10 sm:-top-12">
                            {couple.profileImage ? (
                                <img
                                    src={couple.profileImage}
                                    alt={`${couple.brideName} & ${couple.groomName}`}
                                    className="w-20 h-20 rounded-full object-cover border-4 border-white shadow-md"
                                />
                            ) : (
                                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-accent-500 to-primary-500 border-4 border-white shadow-md flex items-center justify-center">
                                    <span className="text-2xl font-bold text-white">
                                        {couple.brideName?.[0]}{couple.groomName?.[0]}
                                    </span>
                                </div>
                            )}
                        </div>

                        <h1 className="text-2xl sm:text-4xl font-display font-bold text-neutral-900">
                            {couple.brideName} &amp; {couple.groomName}
                        </h1>
                        <p className="text-sm sm:text-base text-neutral-600 mt-2">
                            {formatDate(couple.eventDetails?.party?.date || couple.eventDetails?.ceremony?.date || couple.weddingDate)}
                        </p>

                        <div className="mt-5">
                            <h2 className="text-xl sm:text-2xl font-display font-bold text-neutral-900 mb-2">
                                ¡Tu presencia es nuestro mejor regalo!
                            </h2>
                            <p className="text-base sm:text-lg text-neutral-600 max-w-2xl mx-auto">
                                Si querés sumarte con uno más, elegí uno de esta lista 💝
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Category Filter - Responsive */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-10">
                {/* MOBILE */}
                <div className="sm:hidden relative">
                    <div className="absolute left-0 top-0 h-10 w-8 bg-gradient-to-r from-accent-50/90 to-transparent pointer-events-none z-10" />
                    <div className="absolute right-0 top-0 h-10 w-8 bg-gradient-to-l from-accent-50/90 to-transparent pointer-events-none z-10" />

                    <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide snap-x snap-mandatory">
                        <button
                            onClick={() => setSelectedCategory("all")}
                            className={`flex-shrink-0 snap-center px-4 py-2 rounded-full text-sm font-semibold transition-all ${selectedCategory === "all"
                                ? "bg-accent-50 text-accent-700 ring-1 ring-accent-200"
                                : "bg-white text-neutral-700 hover:bg-neutral-50 border border-neutral-200"
                                }`}
                        >
                            {/* ✅ CAMBIO: Sin filtrar por reserved */}
                            Todos ({gifts.length})
                        </button>

                        {giftCategories
                            .filter(cat => gifts.some(g => g.category === cat.slug)) 
                            .map(cat => {
                                const IconComponent = cat.Icon;
                                const categoryGifts = gifts.filter(g => g.category === cat.slug); {/* ✅ CAMBIO: Sin filtrar por reserved */}

                                return (
                                    <button
                                        key={cat.id}
                                        onClick={() => setSelectedCategory(cat.slug)}
                                        className={`flex-shrink-0 snap-center px-4 py-2 rounded-full text-sm font-semibold transition-all inline-flex items-center gap-2 whitespace-nowrap ${selectedCategory === cat.slug
                                            ? "bg-accent-50 text-accent-700 ring-1 ring-accent-200"
                                            : "bg-white text-neutral-700 hover:bg-neutral-50 border border-neutral-200"
                                            }`}
                                    >
                                        <IconComponent className="w-4 h-4" />
                                        {cat.name} ({categoryGifts.length})
                                    </button>
                                );
                            })}
                    </div>

                    <p className="text-center text-xs text-neutral-400 mt-2">
                        ← Deslizá para ver más →
                    </p>
                </div>

                {/* DESKTOP */}
                <div className="hidden sm:flex flex-wrap gap-2 justify-center">
                    <button
                        onClick={() => setSelectedCategory("all")}
                        className={`px-4 py-2 rounded-full text-sm font-semibold transition-all ${selectedCategory === "all"
                            ? "bg-accent-50 text-accent-700 ring-1 ring-accent-200"
                            : "bg-white text-neutral-700 hover:bg-neutral-50 border border-neutral-200"
                            }`}
                    >
                        {/* ✅ CAMBIO: Sin filtrar por reserved */}
                        Todos ({gifts.length})
                    </button>

                    {giftCategories
                        .filter(cat => gifts.some(g => g.category === cat.slug))
                        .map(cat => {
                            const IconComponent = cat.Icon;
                            const categoryGifts = gifts.filter(g => g.category === cat.slug); {/* ✅ CAMBIO: Sin filtrar por reserved */}

                            return (
                                <button
                                    key={cat.id}
                                    onClick={() => setSelectedCategory(cat.slug)}
                                    className={`px-4 py-2 rounded-full text-sm font-semibold transition-all inline-flex items-center gap-2 ${selectedCategory === cat.slug
                                        ? "bg-accent-50 text-accent-700 ring-1 ring-accent-200"
                                        : "bg-white text-neutral-700 hover:bg-neutral-50 border border-neutral-200"
                                        }`}
                                >
                                    <IconComponent className="w-4 h-4" />
                                    {cat.name} ({categoryGifts.length})
                                </button>
                            );
                        })}
                </div>
            </div>
<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-6 pb-6">
  <div className="flex items-center justify-end">
    <div className="inline-flex items-center gap-2 bg-white/80 backdrop-blur border border-neutral-200 rounded-xl px-3 py-2 shadow-sm">
      <span className="text-xs font-semibold text-neutral-500">Ordenar por</span>

      <select
        value={sortMode}
        onChange={(e) => setSortMode(e.target.value)}
        className="text-sm font-semibold text-neutral-800 bg-transparent outline-none"
      >
        <option value="relevancia">Relevancia</option>
        <option value="libres">Regalos libres primero</option>
        <option value="completados">Ya regalados primero</option>
        <option value="precioAsc">Precio: menor a mayor</option>
        <option value="precioDesc">Precio: mayor a menor</option>
      </select>
    </div>
  </div>
</div>
            {/* Gifts Grid */}
            <div data-catalog className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
                {availableGifts.length === 0 ? (
                    <div className="bg-white rounded-2xl p-12 text-center shadow-sm">
                        <div className="text-6xl mb-4">🎁</div>
                        <h3 className="text-xl font-semibold text-neutral-900 mb-2">
                            {/* ✅ CAMBIO: Mensaje más neutro */}
                            No hay regalos en esta categoría
                        </h3>
                        <p className="text-neutral-600">
                            Probá con otra categoría, ¡seguro encontrás algo lindo!
                        </p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                        {availableGifts.map(gift => {
                            const category = giftCategories.find(c => c.slug === gift.category);
                            const IconComponent = category?.Icon;

                            const progress = ((gift.amountReceived || 0) / gift.price) * 100;
                            const hasContributions = (gift.amountReceived || 0) > 0;
                            const remaining = Math.max(0, gift.price - (gift.amountReceived || 0));
                            const isCompleted = progress >= 100;

                            return (
                                <div
                                    key={gift.id}
                                    className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer group"
                                    onClick={() => setSelectedGift(gift)}
                                >
                                    <div className="relative h-48 bg-neutral-100 overflow-hidden">
                                        {gift.image ? (
                                            <img
                                                src={gift.image}
                                                alt={gift.name}
                                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                                            />
                                        ) : (
                                            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-accent-100 to-accent-200">
                                                {IconComponent && (
                                                    <IconComponent className="w-16 h-16 text-accent-600" strokeWidth={1.5} />
                                                )}
                                            </div>
                                        )}

                                        {category && (
                                            <div className="absolute top-3 left-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-neutral-700 flex items-center gap-1">
                                                {IconComponent && <IconComponent className="w-3 h-3" />}
                                                {category.name}
                                            </div>
                                        )}

                                        {/* ✅ CAMBIO: Badge muestra porcentaje */}
                                        {isCompleted && (
                                            <div className="absolute top-3 right-3 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1">
                                                ✓ {Math.round(progress)}% 🎉
                                            </div>
                                        )}
                                    </div>

                                    <div className="p-5">
                                        <h3 className="text-lg font-display font-bold text-neutral-900 mb-2 line-clamp-2">
                                            {gift.name}
                                        </h3>

                                        {gift.description && (
                                            <p className="text-sm text-neutral-600 mb-3 line-clamp-2">
                                                {gift.description}
                                            </p>
                                        )}

                                        <div className="mb-3 min-h-[42px]">
  {hasContributions ? (
    <>
      {/* progress bar */}
      <div className="w-full h-2 bg-neutral-200 rounded-full overflow-hidden">
        <div
          className={`h-full transition-all duration-500 ${
            isCompleted
              ? 'bg-gradient-to-r from-green-500 to-green-600'
              : 'bg-gradient-to-r from-accent-500 to-accent-600'
          }`}
          style={{ width: `${Math.min(progress, 100)}%` }}
        />
      </div>

      <div className="flex items-center justify-between mt-1.5">
        <p className="text-xs text-neutral-500">
          {isCompleted ? (
            <span className="text-green-600 font-medium">¡Completado! 🎉</span>
          ) : (
            <>{Math.round(progress)}% completado</>
          )}
        </p>
        <p className="text-xs text-neutral-500">
          {gift.contributors?.length || 0} aporte
          {gift.contributors?.length === 1 ? '' : 's'}
        </p>
      </div>
    </>
  ) : (
    <p className="text-xs text-neutral-400 italic mt-1">
      Arrancá vos 💛
    </p>
  )}
</div>

                                        <div className="flex items-center justify-between">
                                            <div>
                                                <span className="text-xl font-semibold text-neutral-600">
                                                    {formatPrice(gift.price)}
                                                </span>
                                                {hasContributions && !isCompleted && (
                                                    <p className="text-xs text-neutral-500 mt-0.5">
                                                        Faltan {formatPrice(remaining)}
                                                    </p>
                                                )}
                                            </div>

                                            <button
  onClick={(e) => {
    e.stopPropagation();
    setCheckoutGift(gift);
  }}
  className={`text-sm font-semibold whitespace-nowrap transition-colors ${
    isCompleted
      ? 'text-green-600 hover:text-green-700'
      : 'text-accent-700 hover:text-accent-800'
  }`}
>
{isCompleted ? 'Sumarte igual →' : 'Regalar →'}</button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>

            {/* Gift Detail Modal */}
            {selectedGift && (
                <div className="modal-overlay">
                    <div
                        className="bg-white rounded-3xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden animate-scale-in"
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div className="relative h-44 sm:h-52 bg-neutral-100">
                            {selectedGift.image ? (
                                <img
                                    src={selectedGift.image}
                                    alt={selectedGift.name}
                                    className="w-full h-full object-cover"
                                />
                            ) : (
                                <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-accent-100 to-accent-200">
                                    {giftCategories.find(c => c.slug === selectedGift.category)?.Icon &&
                                        React.createElement(
                                            giftCategories.find(c => c.slug === selectedGift.category).Icon,
                                            { className: "w-16 h-16 text-accent-600", strokeWidth: 1.5 }
                                        )}
                                </div>
                            )}

                            <button
                                onClick={() => setSelectedGift(null)}
                                className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm w-9 h-9 rounded-full flex items-center justify-center hover:bg-white transition-colors"
                                aria-label="Cerrar"
                            >
                                ✕
                            </button>
                        </div>

                        <div className="p-6 text-center">
                            <h2 className="text-2xl font-display font-bold text-neutral-900 mb-2">
                                {selectedGift.name}
                            </h2>

                            {selectedGift.description && (
                                <p className="text-neutral-600 mb-5 leading-relaxed line-clamp-2">
                                    {selectedGift.description}
                                </p>
                            )}

                            <div className="bg-neutral-50 border border-neutral-200/70 rounded-2xl px-5 py-4 mb-5">
                                <div className="flex items-center justify-between">
                                    <span className="text-sm text-neutral-500">Precio</span>
                                    <span className="text-2xl font-bold text-accent-600">
                                        {formatPrice(selectedGift.price)}
                                    </span>
                                </div>
                            </div>

                            <button
                                onClick={() => setCheckoutGift(selectedGift)}
                                className="w-full bg-accent-500 text-white py-3.5 rounded-2xl font-semibold hover:bg-accent-600 transition-colors shadow-sm hover:shadow-md"
                            >
                                Elegir este regalo
                            </button>

                            <button
                                onClick={() => setSelectedGift(null)}
                                className="w-full mt-2 py-2.5 text-sm text-neutral-600 hover:text-neutral-800 hover:bg-neutral-50 rounded-2xl transition-colors"
                            >
                                Volver a la lista
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Event Details Sidebar */}
            {showEventDetails && (
                <div
                    className={`fixed inset-0 z-50 flex items-start justify-end p-4 sm:p-6 bg-black/40 backdrop-blur-sm transition-opacity duration-200 ${eventOpen ? "opacity-100" : "opacity-0"
                        }`}
                    onClick={() => setShowEventDetails(false)}
                >
                    <div
                        className={`w-full max-w-sm bg-white rounded-3xl shadow-2xl border border-neutral-200/70 overflow-hidden max-h-[90vh]
      transform transition-all duration-200 ease-out ${eventOpen ? "translate-x-0 opacity-100" : "translate-x-6 opacity-0"
                            }`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="sticky top-0 bg-white/90 backdrop-blur border-b border-neutral-200 px-5 py-4 flex items-center justify-between">
                            <h3 className="text-xl font-display font-bold text-neutral-900">
                                Detalles del evento
                            </h3>

                            <button
                                onClick={() => setShowEventDetails(false)}
                                className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-neutral-200 flex items-center justify-center transition-colors"
                                aria-label="Cerrar"
                            >
                                ✕
                            </button>
                        </div>

                        <div className="p-5 overflow-y-auto space-y-6 max-h-[calc(90vh-140px)]">
                            {couple?.eventDetails?.ceremony && (
                                <div className="rounded-2xl border border-neutral-200 p-5">
                                    <div className="flex items-center gap-3 mb-4">
                                        <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                                            <span className="text-lg">⛪</span>
                                        </div>
                                        <div>
                                            <p className="text-xs uppercase tracking-widest text-neutral-400">Ceremonia</p>
                                            <h4 className="font-display font-semibold text-lg text-neutral-900">
                                                {couple.eventDetails.ceremony.location || 'Ceremonia'}
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="space-y-2 text-neutral-700">
                                        {couple.eventDetails.ceremony.date && (
                                            <p className="text-sm font-semibold text-accent-700">
                                                📅 {formatDate(couple.eventDetails.ceremony.date)}
                                            </p>
                                        )}

                                        {couple.eventDetails.ceremony.time && (
                                            <p className="text-sm font-semibold text-accent-700">
                                                🕐 {couple.eventDetails.ceremony.time}
                                            </p>
                                        )}

                                        {couple.eventDetails.ceremony.address && (
                                            <p className="text-sm text-neutral-600">
                                                📍 {couple.eventDetails.ceremony.address}
                                            </p>
                                        )}

                                        {couple.eventDetails.ceremony.details && (
                                            <p className="text-sm text-neutral-500 italic">
                                                {couple.eventDetails.ceremony.details}
                                            </p>
                                        )}

                                        {couple.eventDetails.ceremony.address && (
                                            <a
                                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(couple.eventDetails.ceremony.address)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="inline-flex items-center justify-center gap-2 mt-3 w-full px-4 py-2.5 bg-blue-500 text-white rounded-xl hover:bg-blue-600 transition-colors text-sm font-semibold"
                                            >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                Cómo llegar
                                            </a>
                                        )}
                                    </div>
                                </div>
                            )}

                            {couple?.eventDetails?.party && (
                                <div className="rounded-2xl border border-neutral-200 p-5">
                                    <div className="flex items-center gap-3 mb-4">
                                        <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                                            <span className="text-lg">🎉</span>
                                        </div>
                                        <div>
                                            <p className="text-xs uppercase tracking-widest text-neutral-400">Fiesta</p>
                                            <h4 className="font-display font-semibold text-lg text-neutral-900">
                                                {couple.eventDetails.party.location || 'Fiesta'}
                                            </h4>
                                        </div>
                                    </div>

                                    <div className="space-y-2 text-neutral-700">
                                        {couple.eventDetails.party.date && (
                                            <p className="text-sm font-semibold text-primary-700">
                                                📅 {formatDate(couple.eventDetails.party.date)}
                                            </p>
                                        )}

                                        {couple.eventDetails.party.time && (
                                            <p className="text-sm font-semibold text-primary-700">
                                                🕐 {couple.eventDetails.party.time}
                                            </p>
                                        )}

                                        {couple.eventDetails.party.address && (
                                            <p className="text-sm text-neutral-600">
                                                📍 {couple.eventDetails.party.address}
                                            </p>
                                        )}

                                        {couple.eventDetails.party.details && (
                                            <p className="text-sm text-neutral-500 italic">
                                                {couple.eventDetails.party.details}
                                            </p>
                                        )}

                                        {couple.eventDetails.party.address && (
                                            <a
                                                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(couple.eventDetails.party.address)}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="inline-flex items-center justify-center gap-2 mt-3 w-full px-4 py-2.5 bg-blue-500 text-white rounded-xl hover:bg-blue-600 transition-colors text-sm font-semibold"
                                            >
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                                Cómo llegar
                                            </a>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Footer */}
            <footer className="bg-white border-t border-neutral-200 py-8">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                        <div className="flex flex-col sm:flex-row items-center gap-3">
                            <Logo className="h-10 sm:h-12" />
                            <div className="hidden sm:block h-8 w-px bg-neutral-200" />
                            <div className="text-center sm:text-left">
                                <p className="text-neutral-900 font-medium">
                                    {couple.brideName} & {couple.groomName}
                                </p>
                                <p className="text-sm text-neutral-600">
                                    Lista de regalos
                                </p>
                            </div>
                        </div>

                        <button
                            onClick={() => setShowContactModal(true)}
                            className="text-sm text-neutral-600 hover:text-accent-600 transition-colors font-medium"
                        >
                            Contacto
                        </button>
                    </div>

                    <div className="mt-6 pt-6 border-t border-neutral-200 text-center">
                        <p className="text-sm text-neutral-600 mb-1">
                            Hecho con 💛 por SobreDigital
                        </p>
                        <p className="text-xs text-neutral-400">
                            © {new Date().getFullYear()} SobreDigital. Todos los derechos reservados.
                        </p>
                    </div>
                </div>
            </footer>

            {/* Contact Modal */}
            {showContactModal && (
                <div className="modal-overlay" onClick={() => setShowContactModal(false)}>
                    <div
                        className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full mx-4 overflow-hidden animate-scale-in max-h-[90vh] overflow-y-auto"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="sticky top-0 bg-gradient-to-r from-accent-500 to-primary-500 text-white px-8 py-6">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h2 className="text-2xl sm:text-3xl font-display font-bold mb-1">
                                        Contacto
                                    </h2>
                                    <p className="text-white/90">
                                        Estamos para ayudarte
                                    </p>
                                </div>
                                <button
                                    onClick={() => setShowContactModal(false)}
                                    className="w-10 h-10 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors"
                                    aria-label="Cerrar"
                                >
                                    ✕
                                </button>
                            </div>
                        </div>

                        <div className="p-8">
                            {!contactSubmitted ? (
                                <form onSubmit={handleContactSubmit} className="space-y-4">
                                    <div>
                                        <label className="block text-sm font-medium text-neutral-700 mb-2">
                                            Nombre *
                                        </label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={contactFormData.name}
                                            onChange={handleContactChange}
                                            required
                                            className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 outline-none transition-all"
                                            placeholder="Tu nombre completo"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-neutral-700 mb-2">
                                            Email *
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={contactFormData.email}
                                            onChange={handleContactChange}
                                            required
                                            className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 outline-none transition-all"
                                            placeholder="tu@email.com"
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-neutral-700 mb-2">
                                            Asunto *
                                        </label>
                                        <select
                                            name="subject"
                                            value={contactFormData.subject}
                                            onChange={handleContactChange}
                                            required
                                            className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 outline-none transition-all"
                                        >
                                            <option value="">Seleccioná un tema</option>
                                            <option value="consulta-regalo">Consulta sobre un regalo</option>
                                            <option value="problema-pago">Problema con el pago</option>
                                            <option value="modificar-aporte">Modificar mi aporte</option>
                                            <option value="otro">Otro</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-neutral-700 mb-2">
                                            Mensaje *
                                        </label>
                                        <textarea
                                            name="message"
                                            value={contactFormData.message}
                                            onChange={handleContactChange}
                                            required
                                            rows="5"
                                            className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-accent-500 focus:border-accent-500 outline-none transition-all resize-none"
                                            placeholder="Contanos en qué podemos ayudarte..."
                                        />
                                    </div>

                                    <div className="flex gap-3 pt-2">
                                        <button
                                            type="button"
                                            onClick={() => setShowContactModal(false)}
                                            className="flex-1 px-6 py-3 bg-neutral-100 text-neutral-700 rounded-lg font-semibold hover:bg-neutral-200 transition-colors"
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            type="submit"
                                            disabled={contactLoading}
                                            className="flex-1 px-6 py-3 bg-accent-500 text-white rounded-lg font-semibold hover:bg-accent-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                        >
                                            {contactLoading ? 'Enviando...' : 'Enviar'}
                                        </button>
                                    </div>
                                </form>
                            ) : (
                                <div className="text-center py-8">
                                    <div className="text-6xl mb-4">✉️</div>
                                    <h3 className="text-2xl font-display font-bold text-neutral-900 mb-3">
                                        ¡Mensaje Enviado!
                                    </h3>
                                    <p className="text-neutral-600 mb-6">
                                        Recibimos tu consulta. Te responderemos a <strong>{contactFormData.email}</strong> en menos de 24 horas.
                                    </p>
                                    <button
                                        onClick={() => {
                                            setShowContactModal(false);
                                            setContactSubmitted(false);
                                            setContactFormData({
                                                name: '',
                                                email: '',
                                                subject: '',
                                                message: ''
                                            });
                                        }}
                                        className="px-8 py-3 bg-accent-500 text-white rounded-lg font-semibold hover:bg-accent-600 transition-colors"
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
{showBackToTop && (
  <button
    onClick={scrollToTop}
    className="fixed bottom-5 right-5 z-50 sm:hidden
               w-12 h-12 rounded-full shadow-lg
               bg-white/90 backdrop-blur border border-neutral-200
               flex items-center justify-center
               text-neutral-700 hover:bg-white transition"
    aria-label="Volver arriba"
  >
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
    </svg>
  </button>
)}
            {/* Checkout Modal */}
            {checkoutGift && (
                <GiftCheckout
                    gift={checkoutGift}
                    couple={{
                        ...couple,
                        gifts: gifts
                    }}
                    onClose={() => {
                        setCheckoutGift(null);
                        refreshGifts();
                    }}
                    onSuccess={() => {
                        refreshGifts();
                    }}
                />
            )}
        </div>
    );
};

export default PublicGiftList;